import { render, staticRenderFns } from "./TripLegResume.vue?vue&type=template&id=685fa45a&scoped=true&"
import script from "./TripLegResume.vue?vue&type=script&lang=js&"
export * from "./TripLegResume.vue?vue&type=script&lang=js&"
import style0 from "./TripLegResume.vue?vue&type=style&index=0&id=685fa45a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "685fa45a",
  null
  
)

export default component.exports